import { connect } from "react-redux";
import { withRouter } from "react-router";
import { push } from "react-router-redux";
import App from "../components/App";

export default withRouter(
  connect(
    (state, props) => ({}),
    (dispatch, props) => ({
      initialActions() {},
      goToPath(path) {
        dispatch(push(path));
      }
    })
  )(App)
);
